import React, { useEffect, useRef, useState } from 'react';

import { getRem } from 'lib/core';
import { Menu, MenuListItem } from 'lib/menu';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { PageDropDownButton } from '../elements';

const StyledPageSize = styled.div`
  align-items: center;
  display: flex;
  height: ${getRem('36px')};
  margin-right: ${({ theme }) => theme.size.spacing.large.value};
`;

const PageSizeMenu = ({
  className = '',
  dataTestId = '',
  dropDownOptions,
  isDisabled = false,
  onSelect,
  pageSize,
  ...other
}) => {
  const labelRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const menuContainerRef = useRef();

  const handleClose = () => {
    setIsOpen(false);
  };
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleSelect = (option) => {
    onSelect(option);
    handleClose();
  };

  useEffect(() => {
    const setIsOpenFromMenu = (event) => {
      if (event.detail.ref === menuContainerRef) setIsOpen(event.detail.openMenu); // this modifies your local state (adjust according to your state implementation)
    };
    document.addEventListener('customMenuOpenEvent', setIsOpenFromMenu); // `customMenuOpenEvent` is what you are listening for
    return () => document.removeEventListener('customMenuOpenEvent', setIsOpenFromMenu);
  }, []);

  return (
    <StyledPageSize className={className ? `${className}-page-size` : undefined} {...other}>
      <PageDropDownButton ref={labelRef} {...{ className, dataTestId, isDisabled, isOpen, pageSize }} />
      <Menu
        onOpen={handleOpen}
        onClose={handleClose}
        data-testid={dataTestId ? `${dataTestId}-page-size-menu` : undefined}
        {...{ className, isOpen, labelRef }}
        {...other}
        ref={menuContainerRef}
      >
        {dropDownOptions.map((option, ind) => (
          <MenuListItem
            className={className}
            dataTestId={dataTestId ? `${dataTestId}-page-menu-item-${ind}` : undefined}
            hideSelectedItemCheckmark={true}
            isSelected={pageSize === option.label}
            key={ind}
            onClick={() => handleSelect(option)}
          >
            {option.label}
          </MenuListItem>
        ))}
      </Menu>
    </StyledPageSize>
  );
};

PageSizeMenu.propTypes = {
  /** Adds new class to Pagination */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** Sets the visible number of items per page */
  dropDownOptions: PropTypes.array.isRequired,
  /** Callback function that is triggered when page size count is changed */
  onSelect: PropTypes.func.isRequired,
  /** Sets the displayed page size label */
  pageSize: PropTypes.string.isRequired,
  /** Disables the rows per page dropdown menu */
  isDisabled: PropTypes.bool,
};

export { PageSizeMenu };
